import React from "react";
import { connect } from "react-redux";

import { isGrantedSome, getUserRoles } from "../../../redux/actions/config/session";

const RestrictedView = (props) => {
    if (isGrantedSome(props.allowedRoles, props.roles)) {
        return <>{props.children}</>;
    }

    return null;
};

function MapStateToProps(state) {
    return {
        roles: getUserRoles(state),
    };
}

const mapDispatchToProps = {};

export default connect(MapStateToProps, mapDispatchToProps)(RestrictedView);
